import { getPreset } from '@cutr/constants/windows/presets';
import { WindowPresetId } from '@cutr/constants/windows/presets';
import { AreaId, WindowSpec } from '@cutr/constants/windows/windows';
import { getFrameDimensions } from '@cutr/constants/windows/windows-geometry.ts';
import { WindowPreset } from '@cutr/constants/windows/windows-presets.ts';
import React from 'react';
import { createContext, useContext } from 'react';

import { getOffsets, useRenderStyles } from './renderStyles';

export type WindowEditorContext = {
  windowSpec?: WindowSpec;
  presetId: WindowPresetId;
  frameWidthMM: number;
  frameHeightMM: number;
  frameConstraints: WindowPreset['frameConstraints'];
  frameX: number;
  frameY: number;
  readonly?: boolean;
  selectedAreaId?: AreaId;
};

export const WindowEditorContext = createContext<WindowEditorContext | null>(
  null
);

export const useWindowEditor = () => {
  const context = useContext(WindowEditorContext);

  if (!context)
    throw new Error(
      'useWindowEditor must be used within a WindowEditorProvider'
    );

  return context;
};

type WindowEditorProviderProps = {
  children: React.ReactNode;
  windowSpec: WindowSpec;
  presetId: WindowPresetId;
  readonly?: boolean;
  selectedAreaId?: AreaId;
};

export const WindowEditorProvider = ({
  children,
  windowSpec,
  presetId,
  readonly,
  selectedAreaId,
}: WindowEditorProviderProps) => {
  const { frameWidthMM, frameHeightMM } = getFrameDimensions(
    windowSpec.frameShape
  );

  const renderStyles = useRenderStyles('editor');

  const { leftMM, bottomMM } = getOffsets(renderStyles);

  const { frameConstraints } = getPreset(presetId);

  return (
    <WindowEditorContext.Provider
      value={{
        windowSpec,
        presetId,
        frameWidthMM,
        frameHeightMM,
        frameConstraints,
        frameX: leftMM,
        frameY: bottomMM,
        readonly,
        selectedAreaId,
      }}
    >
      {children}
    </WindowEditorContext.Provider>
  );
};
